import React, { useState } from "react";
import logo from "../../assets/head.svg";
import "./CustomerVerification.scss";
import Button from "../../components/button/Button";
import Input from "../../components/input/Input";
import PhoneInput from "../../components/phoneInput/PhoneInput";
import VerificationModal from "../../components/modal/verificationModal/VerificationModal";
import FailedModal from "../../components/modal/failedModal/FailedModal";
import {
  getCustomerEmail,
  getCustomerPhoneNumber,
  sendOTPtoEmail,
  sendOTPtoPhone,
  verifyCustomerEmail,
  verifyCustomerPhoneNumber,
} from "../../utilities/api/CustomerService";
import { useNavigate } from "react-router-dom";
import base from "../../assets/base.svg";
import logoIC from "../../assets/logo.svg";
const CustomerVerification: React.FC = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<string>("email");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [isVerificationModalOpen, setIsVerificationModalOpen] =
    useState<boolean>(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>("");
  const [phoneError, setPhoneError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [verificationValue, setVerificationValue] = useState<string>("");
  const [requestID, setRequestID] = useState<any>("");

  const validateEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };
  return (
    <div className='cust-reg-verification'>
      <div className='header-tab'>Customer Registration</div>
      <div className='content-register-veri'>
        <div
          className='left-content-register'
          style={{ backgroundImage: `url(${base})` }}
        >
          <div className='left-logo-container'>
            <img alt='' src={logoIC} className='logoic-img' />
          </div>
          <div className='left-text-container'>
            The multipurpose tool you need to succeed in business
          </div>
        </div>
        <div className='right-content-register'>
          <div className='regitser-container'>
            <div className='register-header'>
              <div className='reg-header-inner'>
                <div className='logo-container'>
                  <img alt='' src={logo} className='logo-img' />
                </div>
                <div>
                  <div className='header-text'>
                    WITMEG Customer Registration
                  </div>
                </div>
              </div>
            </div>
            <div className='reg-selection'>
              <div className='reg-slct-inner'>
                <div className='reg-slct-inner-head'>Verify your account</div>
                <div className='reg-slct-inner-sub'>
                  Welcome Back! For your security and to ensure it's really you,
                  We just need to verify your account. Please Choose your
                  preffered method of verification below
                </div>
                <div className='selection-cont'>
                  <div className='selction-cont-left-veri'>
                    <div
                      className={`radio-btn ${
                        selected === "email" ? "radio-btn-selected" : ""
                      }`}
                      onClick={() => {
                        if (!isLoading) {
                          setPhoneError("");
                          setPhoneNumber("");
                          setSelected("email");
                        }
                      }}
                    >
                      {selected === "email" && (
                        <div className='selected-radio' />
                      )}
                    </div>
                    <div>
                      <div className='selction-cont-left-head'>
                        Verify via email
                      </div>
                      <div className='selction-cont-left-sub'>
                        Receive an email with an OTP to verify your account
                      </div>
                    </div>
                  </div>
                  {selected === "email" && (
                    <div className='selction-cont-right-veri'>
                      <Input
                        label='Email'
                        value={email}
                        onChange={(value) => {
                          setEmailError("");
                          setEmail(value);
                        }}
                        error={emailError}
                      />
                      <div className='btn-wrapper'>
                        <Button
                          text='Send'
                          onClick={() => {
                            if (validateEmail(email)) {
                              if (!isLoading) {
                                setVerificationValue(email);
                                setIsLoading(true);
                                setEmailError("");
                                verifyCustomerEmail(email)
                                  .then((response) => {
                                    if (response === "Email already exists") {
                                      sendOTPtoEmail(email)
                                        .then((responseOTP) => {
                                          if (responseOTP) {
                                            setRequestID(responseOTP);
                                            setIsLoading(false);
                                            setIsVerificationModalOpen(true);
                                            setEmail("");
                                          }
                                        })
                                        .catch(() => {
                                          setIsLoading(false);
                                          setEmailError("Something went wrong");
                                        });
                                    } else {
                                      setIsLoading(false);
                                      setEmailError("Invalid Email");
                                    }
                                  })
                                  .catch((error) => {
                                    setIsLoading(false);
                                    setEmailError("Invalid Email");
                                  });
                              }
                            } else {
                              setEmailError("Invalid email format");
                            }
                          }}
                          isPrimary
                          isDisable={email === ""}
                          isLoading={isLoading}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className='selection-cont-bt'>
                  <div className='selction-cont-left-veri'>
                    <div
                      className={`radio-btn ${
                        selected === "phone" ? "radio-btn-selected" : ""
                      }`}
                      onClick={() => {
                        if (!isLoading) {
                          setEmail("");
                          setEmailError("");
                          setSelected("phone");
                        }
                      }}
                    >
                      {selected === "phone" && (
                        <div className='selected-radio' />
                      )}
                    </div>
                    <div>
                      <div className='selction-cont-left-head'>
                        Verify via phone
                      </div>
                      <div className='selction-cont-left-sub'>
                        Receive an OTP via SMS to verify your account
                      </div>
                    </div>
                  </div>
                  {selected === "phone" && (
                    <div className='selction-cont-right-veri'>
                      <PhoneInput
                        label='Phone'
                        value={phoneNumber}
                        onChange={(value: number) => {
                          setPhoneNumber(value.toString());
                        }}
                        error={phoneError}
                      />
                      <div className='btn-wrapper'>
                        <Button
                          text='Send'
                          onClick={() => {
                            if (phoneNumber !== "") {
                              if (!isLoading) {
                                setVerificationValue(phoneNumber);
                                setIsLoading(true);
                                setPhoneError("");
                                verifyCustomerPhoneNumber(phoneNumber)
                                  .then((response) => {
                                    if (
                                      response === "Phone number already exists"
                                    ) {
                                      sendOTPtoPhone(phoneNumber)
                                        .then((responseOTP) => {
                                          if (responseOTP) {
                                            setRequestID(responseOTP);
                                            setIsLoading(false);
                                            setIsVerificationModalOpen(true);
                                            setEmail("");
                                          }
                                        })
                                        .catch(() => {
                                          setIsLoading(false);
                                          setPhoneError("Something went wrong");
                                        });
                                    } else {
                                      setIsLoading(false);
                                      setPhoneError("Invalid Phonenumber");
                                    }
                                  })
                                  .catch((error) => {
                                    setIsLoading(false);
                                    setPhoneError("Invalid Phonenumber");
                                  });
                              }
                            } else {
                            }
                          }}
                          isPrimary
                          isDisable={phoneNumber === ""}
                          isLoading={isLoading}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='pd-btn-cont-veri'>
            <Button
              text='Back'
              isPrimary={false}
              onClick={() => {
                navigate("/");
              }}
              isBorder
            />
          </div>
        </div>
      </div>
      {isVerificationModalOpen && (
        <VerificationModal
          onClose={() => {
            setIsVerificationModalOpen(false);
          }}
          value={verificationValue}
          onResend={() => {
            if (validateEmail(verificationValue)) {
              sendOTPtoEmail(verificationValue)
                .then((responseOTP) => {
                  if (responseOTP) {
                    setRequestID(responseOTP);
                  }
                })
                .catch(() => {
                  setIsLoading(false);
                  setEmailError("Something went wrong");
                });
            } else {
              sendOTPtoPhone(verificationValue)
                .then((responseOTP) => {
                  if (responseOTP) {
                    setRequestID(responseOTP);
                  }
                })
                .catch(() => {
                  setIsLoading(false);
                  setPhoneError("Something went wrong");
                });
            }
          }}
          onSucess={() => {
            if (validateEmail(verificationValue)) {
              getCustomerEmail(verificationValue)
                .then((response) => {
                  setTimeout(() => {
                    setIsVerificationModalOpen(false);
                    navigate("/customer/verified", {
                      state: { data: response },
                    });
                  }, 1000);
                })
                .catch((error) => {
                  setIsFailedModalOpen(true);
                });
            } else {
              getCustomerPhoneNumber(verificationValue)
                .then((response) => {
                  setTimeout(() => {
                    setIsVerificationModalOpen(false);
                    navigate("/customer/verified", {
                      state: { data: response },
                    });
                  }, 1000);
                })
                .catch((error) => {
                  setIsFailedModalOpen(true);
                });
            }
          }}
          requestID={requestID}
          onFailed={() => {
            setIsFailedModalOpen(true);
          }}
        />
      )}
      {isFailedModalOpen && (
        <FailedModal
          onClose={() => {
            setIsFailedModalOpen(false);
          }}
        />
      )}
    </div>
  );
};
export default CustomerVerification;
